module.exports = __webpack_public_path__ + "img/储备人才.b3eb767d.png";